import { SMART_ID_AUTH_TRANSACTION_ACTION_TYPE } from "./smart-id-auth-transaction.action";

export const SMART_ID_AUTH_TRANSACTION_MESSAGE_CONTEXT = {
	getVerificationStatus: SMART_ID_AUTH_TRANSACTION_ACTION_TYPE.getVerificationStatus,
	initializeVerification: SMART_ID_AUTH_TRANSACTION_ACTION_TYPE.initializeVerification,
	initializeAuthTransaction: SMART_ID_AUTH_TRANSACTION_ACTION_TYPE.initializeAuthTransaction,
	cancelLastVerification: SMART_ID_AUTH_TRANSACTION_ACTION_TYPE.cancelLastVerification,
};

export const REDIRECT_HASH = "redirect";
